import FormControlLabel from '@mui/material/FormControlLabel';
import MuiRadio from '@mui/material/Radio';
import { forwardRef, type ChangeEvent, type FocusEventHandler, type ReactNode, type Ref } from 'react';

export type RadioProps = {
  value?: string;
  label?: ReactNode;
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  name?: string;
  /** Matches MUI `Radio` / `SwitchBase` handler shape. */
  onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  onBlur?: FocusEventHandler<HTMLElement>;
  onFocus?: FocusEventHandler<HTMLElement>;
  size?: 'small' | 'medium';
  inputRef?: Ref<HTMLInputElement>;
};

/** Design-system Radio — wraps MUI Radio; */
export const Radio = forwardRef<HTMLButtonElement, RadioProps>(function Radio(
  { value, label, checked, defaultChecked, disabled, name, onChange, onBlur, onFocus, size = 'medium', inputRef },
  ref
) {
  const control = (
    <MuiRadio
      ref={ref}
      className="SmRadio-root"
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      name={name}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      size={size}
      inputRef={inputRef}
      value={label == null ? value : undefined}
    />
  );

  if (label == null) return control;

  return <FormControlLabel value={value} control={control} label={label} disabled={disabled} />;
});
